import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import Select from "react-select";
import "leaflet-routing-machine";
import "leaflet/dist/leaflet.css";
import Busarrivalreport from "../report/livereport/Busarrivalreport";
import tablelogo from "../../Images/table.png";
import maplogo from "../../Images/maplogo2.png";
import Trackmap from "./Trackmap";
import { getinitialdata } from "../../services/Trackingservice";
import { useNavigate } from "react-router-dom";
import { MdLiveTv, MdList } from "react-icons/md";
import { FaBus } from "react-icons/fa";
const Track = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { tab } = useParams();
  const defaulttab = "trackmap";
  useEffect(() => {
    if (!tab) {
      setType(defaulttab);
    } else {
      setType(tab);
    }
  }, [tab]);
  const [type, setType] = useState("");
  const [routeoption, setRouteoption] = useState([]);
  const [selectedroute, setSelectedroute] = useState(null);
  const [busoption, setBusoption] = useState([]);
  const [allbus, setAllbus] = useState([]);
  const [selectedbus, setSelectedbus] = useState(null);
  const [selectedshift, setSelectedshift] = useState(null);
  const [view, setView] = useState("ALL");
  //transferdata
  const [allBusses, setAllBuses] = useState([]);
  const [allRoutes, setAllRoutes] = useState([]);
  const [allStops, setAllStops] = useState([]);
  const [shiftoption, setShiftoption] = useState([
    { label: "Pickup", value: "PICKUP" },
    { label: "Drop", value: "DROP" },
  ]);
  const [param, setParam] = useState({
    bus_id: "",
    route_id: "",
    trip_mode: "",
  });
  useEffect(() => {
    setSelectedroute(null);
    setSelectedshift(null);
    setSelectedbus(null);
  }, [view]);
  useEffect(() => {
    if (selectedbus?.value) {
      const route = routeoption.find(
        (data) => data.value == selectedbus.route_id
      );
      console.log(route);
      setSelectedroute(route || null);
    } else {
      setSelectedroute(null);
    }
  }, [selectedbus]);

  useEffect(() => {
    if (selectedroute?.value) {
      const filtered = allbus.filter(
        (data) => String(data.route_id) === String(selectedroute.value)
      );
      setBusoption(filtered);
    } else {
      setBusoption(allbus); // Show all buses if no route selected
    }
  }, [selectedroute, allbus]);
  useEffect(() => {
    setParam({
      bus_id: selectedbus?.value || "",
      route_id: selectedroute?.value || "",
      trip_mode: selectedshift?.value || "",
    });
  }, [selectedbus, selectedroute, selectedshift]);
  useEffect(() => {
    getinitialdata({ display_type: view })
      .then((res) => {
        const data = res.data;
        const allroute = data?.route_data.map((data) => ({
          value: data?.id,
          label: data?.name,
        }));
        setRouteoption(allroute);
        const initialBuses = data.bus_data.map((u) => ({
          route_id: u?.route?.id,
          value: u?.bus?.id,
          label: u?.bus?.number_plate,
        }));
        setBusoption(initialBuses);
        setAllbus(initialBuses);
        //transferdata
        const route = data?.route_data.map((data) => ({
          id: data?.id,
          polyline: data.polyline,
          stops: data?.stops,
        }));
        setAllRoutes(route);
        const allStops = data?.route_data.flatMap((r) =>
          r.stops.map((s) => ({
            id: s.stop.id,
            name: s.stop.name,
            latitude: parseFloat(s.stop.latitude),
            longitude: parseFloat(s.stop.longitude),
          }))
        );
        setAllStops(allStops);
        const buses =
          data.bus_data && data.bus_data.length > 0
            ? data.bus_data.map((u) => ({
                route_id: u?.route?.id,
                id: u.bus?.id,
                name: u.bus?.number_plate,
                position:
                  u.bus?.latitude != null && u.bus?.longitude != null
                    ? [
                        parseFloat(u.bus?.latitude),
                        parseFloat(u.bus?.longitude),
                      ]
                    : null,
                shift: u?.shift?.name,
                routeName: u.route?.name,
                trip_mode: u.trip_mode,
              }))
            : [];

        setAllBuses(buses);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [view]);

  return (
    <div className="container-fluid">
      <div className="d-flex flex-column flex-md-row justify-content-between gap-2">
        <div>
          <span
            className="text-primary"
            style={{ fontSize: "1.3rem", fontWeight: "500" }}
          >
            Tracking
          </span>
          <ol className="breadcrumb breadcrumb-arrow mb-0">
            <li className="breadcrumb-item">
              <Link to="/dashboard">Dashboard</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Tracking
            </li>
          </ol>
        </div>
        <div className="d-flex flex-wrap flex-md-row gap-2">
          {location.pathname == "/tracking/trackmap" && (
            <div className="view-toggle d-flex justify-content-center align-self-start">
              <button
                className={`toggle-btn ${view === "ALL" ? "active" : ""}`}
                onClick={() => setView("ALL")}
              >
                <FaBus className="me-1" size={14}/>
                All
              </button>
              <button
                className={`position-relative toggle-btn ${
                  view === "CURRENT_TRIP" ? "active" : ""
                }`}
                onClick={() => setView("CURRENT_TRIP")}
              >
                <span className="live-indicator-wrapper position-absolute">
                  <span className="pulse-ring"></span>
                  <span className="live-dot"></span>
                </span>
                
                <span className="position-relative d-inline-block">Live</span>
              </button>
            </div>
            // <div className="custom-toggle-wrapper">
            //   <div
            //     className={`active-toggle-bg ${
            //       view === "CURRENT_TRIP" ? "right" : "left"
            //     }`}
            //   />

            //   <button
            //     className={`toggle-button ${view === "ALL" ? "active" : ""}`}
            //     onClick={() => setView("ALL")}
            //   >
            //     <MdList size={16} className="me-1" />
            //     All
            //   </button>

            //   <button
            //     className={`toggle-button ${
            //       view === "CURRENT_TRIP" ? "active" : ""
            //     }`}
            //     onClick={() => setView("CURRENT_TRIP")}
            //   >
            //     <div className="live-indicator">
            //       <span className="live-pulse"></span>
            //       <span className="live-dot"></span>
            //     </div>
            //     <FaBus size={16} className="me-1" />
            //     Live
            //   </button>
            // </div>
          )}

          <div
            className="flex-fill flex-md-grow-0 w-md-auto"
            style={{ maxWidth: "250px" }}
          >
            <Select
              className="react-select"
              placeholder="Select Route"
              isClearable
              classNamePrefix="select"
              options={routeoption}
              value={selectedroute}
              onChange={(selected) => {
                setSelectedbus(null);
                setSelectedroute(selected);
              }}
              styles={{
                menu: (provided) => ({
                  ...provided,
                  zIndex: 9999,
                }),
              }}
            />
          </div>
          <div className="flex-fill flex-md-grow-0">
            <Select
              className="react-select"
              placeholder="Select Bus"
              classNamePrefix="select"
              options={busoption}
              isClearable
              value={selectedbus}
              onChange={setSelectedbus}
              styles={{
                menu: (provided) => ({
                  ...provided,
                  zIndex: 9999,
                }),
              }}
            />
          </div>
          <div className="flex-fill flex-md-grow-0">
            <Select
              className="react-select"
              placeholder="Trip Mode"
              classNamePrefix="select"
              options={shiftoption}
              isClearable
              value={selectedshift}
              onChange={setSelectedshift}
              styles={{
                menu: (provided) => ({
                  ...provided,
                  zIndex: 9999,
                }),
              }}
            />
          </div>
          <div className="btn-group align-self-start">
            <button
              className={`btn btn-outline-primary py-2 ${
                type === "trackmap" ? "active" : ""
              }`}
              onClick={() => {
                navigate("/tracking/trackmap");
                setSelectedbus(null);
                setSelectedroute(null);
              }}
            >
              <img src={maplogo} />
            </button>
            <button
              className={`btn btn-outline-primary py-2 ${
                type === "livetable" ? "active" : ""
              }`}
              onClick={() => {
                navigate("/tracking/livetable");
                setSelectedbus(null);
                setSelectedroute(null);
              }}
            >
              <img src={tablelogo} />
            </button>
          </div>
        </div>
      </div>
      <div className="row">
        {type === "trackmap" ? (
          <>
            <div className="col-12">
              <Trackmap
                param={param}
                selectedbus={selectedbus}
                selectedroute={selectedroute}
                allRoutes={allRoutes}
                allBusses={allBusses}
                allStops={allStops}
              />
            </div>
          </>
        ) : type === "livetable" ? (
          <>
            <div className="col-12">
              <Busarrivalreport param={param} />
            </div>
          </>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default Track;
